import styled, { css } from 'styled-components/macro';
import { Button } from '@yme/atoms/button';
import { ButtonsGroupStyled } from '@yme/atoms/buttons-group';
import { colorCoreGray500 } from '@yme/tokens/colors';
import { ADAPTIVE } from '@yme/tokens/screen';
import { INDENT } from '@yme/tokens/sizes';
export const ModalWindowFooterStyled = styled.div `
  display: flex;
  position: relative;
  justify-content: ${({ leftSideText }) => (leftSideText ? 'space-between' : 'flex-end')};
  align-items: center;
  box-sizing: border-box;

  width: 100%;

  ${({ isHiddenBorder }) => !isHiddenBorder &&
    css `
      padding: ${INDENT.xs} ${INDENT.sm};
      /* Stroke/Light/Over */
      box-shadow: inset 0 1px 0 ${colorCoreGray500};
    `}
`;
export const ButtonsGroupInnerStyled = styled(ButtonsGroupStyled) `
  justify-content: flex-end;

  ${({ isWrapReverse }) => isWrapReverse &&
    css `
      flex-wrap: wrap-reverse;
    `}

  & > button {
    ${({ isArrangedByLine, count }) => {
    if (count === 1) {
        return css `
          width: auto;

          ${ADAPTIVE.maxWidth.tablet} {
            width: 100%;
          }
        `;
    }
    return css `
        ${() => (isArrangedByLine ? 'width: auto;' : 'width: 100%;')}
      `;
}}
  }
`;
export const ButtonStyled = styled(Button) `
  ${({ isBtnsWidthStyleReset }) => isBtnsWidthStyleReset && 'width: unset;'}
  ${({ isFullWidth }) => isFullWidth && 'flex-grow: 1;'}

  ${({ customPadding }) => customPadding && `padding: ${customPadding};`}
`;
